import { gql } from "@apollo/client";

export const instructorsAdvancedSearch = gql`
  query instructorsAdvancedSearch(
    $originId: ID!
    $scenarioId: ID!
    $filter: InstructorFilterInput
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      instructorsAdvancedSearch(filter: $filter) {
        items {
          id
          code
          name
          priority
          usable
          contract
          assignment {
            averagePerIntervalBlocks
            blocks
            usagePercentage
          }
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          page
          size
          total
        }
      }
    }
  }
`;
